import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  name: string;
  url: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: `https://kuikanys.com${item.url}`,
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
      <nav aria-label="面包屑导航" className="flex items-center gap-1.5 text-sm text-foreground-400 flex-wrap">
        {items.map((item, index) => (
          <span key={item.url} className="flex items-center gap-1.5">
            {index > 0 && <i className="ri-arrow-right-s-line text-xs"></i>}
            {index === items.length - 1 ? (
              <span className="text-foreground-200 font-medium">{item.name}</span>
            ) : (
              <Link to={item.url} className="hover:text-primary-400 transition-colors cursor-pointer">
                {item.name}
              </Link>
            )}
          </span>
        ))}
      </nav>
    </>
  );
}